let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jtt0C")).then(() => parcelRequire('gkIoe'));